import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { WithdrawalSettings, ProfileSettings, PasswordSettings } from '../../features/settings/components';
import { useAuthStore } from '../../stores/authStore';
import { useSubscription } from '../../features/subscription/hooks/useSubscription';
import { formatDate } from '../../lib/utils';
import { ROUTES } from '../../config/routes';
import { usePageTitle } from '../../hooks/usePageTitle';

export const SettingsPage: React.FC = () => {
  usePageTitle('設定');
  const { user, clearAuth } = useAuthStore();
  const navigate = useNavigate();

  const { data: subscriptionData } = useSubscription();
  const subscription = subscriptionData?.data;
  const plan = subscription?.plan ?? user?.plan ?? 'trial';
  const currentPeriodEnd = subscription?.current_period_end;

  const [deleteAccountOpen, setDeleteAccountOpen] = useState(false);

  const handleLogout = () => {
    clearAuth();
    navigate(ROUTES.LOGIN);
  };

  const cardStyle: React.CSSProperties = {
    maxWidth: '680px',
    borderRadius: '12px',
    padding: '24px',
    border: '1px solid #E2E8F0',
    background: '#fff',
    marginBottom: '16px',
  };

  return (
    <div>
      {/* page-head */}
      <div style={{ marginBottom: '28px' }}>
        <div style={{ fontSize: '22px', fontWeight: 700, color: '#0F172A', marginBottom: '4px' }}>設定</div>
        <div style={{ fontSize: '13px', color: '#94A3B8' }}>アカウントの情報を確認・変更できます。</div>
      </div>

      {/* 【A】プロフィールcard */}
      <ProfileSettings />

      {/* パスワード変更card(非googleユーザーのみ) */}
      {user?.auth_provider !== 'google' && <PasswordSettings />}

      {/* 【B】現在のプランcard */}
      <div style={{ ...cardStyle, display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '16px' }}>
        <div>
          <div style={{ fontSize: '15px', fontWeight: 700, color: '#0F172A', marginBottom: '4px' }}>現在のプラン</div>
          <div style={{ fontSize: '13px', color: '#64748B' }}>
            {plan} プラン ・ {currentPeriodEnd ? `次回更新 ${formatDate(currentPeriodEnd, 'yyyy年M月d日')}` : '次回更新日未定'}
          </div>
        </div>
        <button
          onClick={() => navigate(ROUTES.SUBSCRIPTION)}
          style={{ background: '#0a7a72', color: '#fff', border: 'none', borderRadius: '8px', padding: '10px 18px', fontSize: '13px', fontWeight: 700, cursor: 'pointer', flexShrink: 0 }}
        >
          プランを変更
        </button>
      </div>

      {/* 退会リンク + ログアウト */}
      <div style={{ maxWidth: '680px', marginTop: '8px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <span
          onClick={() => setDeleteAccountOpen(true)}
          style={{ fontSize: '13px', color: '#94A3B8', cursor: 'pointer', textDecoration: 'underline' }}
        >
          退会についてはこちら
        </span>
        <button
          data-testid="logout-button"
          onClick={handleLogout}
          style={{ background: 'none', border: 'none', padding: '0', fontSize: '13px', color: '#64748B', cursor: 'pointer' }}
        >
          ログアウト
        </button>
      </div>

      {/* 退会モーダル */}
      {deleteAccountOpen && (
        <div style={{ position: 'fixed', inset: 0, zIndex: 50, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)' }} onClick={() => setDeleteAccountOpen(false)} />
          <div style={{ position: 'relative', background: '#fff', borderRadius: '12px', boxShadow: '0 20px 60px rgba(0,0,0,0.15)', maxWidth: '480px', width: '90%', maxHeight: '90vh', overflowY: 'auto' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '20px 24px 12px' }}>
              <span style={{ fontSize: '15px', fontWeight: 700 }}>アカウントの削除</span>
              <button onClick={() => setDeleteAccountOpen(false)} style={{ background: 'none', border: 'none', fontSize: '18px', color: '#94A3B8', cursor: 'pointer' }}>✕</button>
            </div>
            <div style={{ padding: '0 24px 24px' }}>
              <WithdrawalSettings />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
